import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { installGlobalErrorLogger } from "@/utils/errorLogger";

// Wire up window.onerror + unhandledrejection capture so runtime JS
// errors auto-log to the backend and show up in the Issues viewer.
installGlobalErrorLogger();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register Service Worker for PWA functionality.
// Skip registration in development — a stale SW will keep serving an
// old cached bundle even after source changes, which produces hard-to-
// debug "fix doesn't apply" / refresh-loop behavior on localhost.
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    // When a new worker takes over (after a deploy), reload once so this page
    // runs the new build instead of the one the old worker cached.
    let reloadedForNewWorker = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (reloadedForNewWorker) return;
      reloadedForNewWorker = true;
      window.location.reload();
    });
    navigator.serviceWorker.register('/service-worker.js', { updateViaCache: 'none' })
      .then(registration => {
        console.log('✅ Service Worker registered successfully:', registration.scope);
        
        // Check for updates periodically
        setInterval(() => {
          registration.update();
        }, 60 * 60 * 1000); // Check every hour
        
        // Listen for updates
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // New service worker available
              console.log('🔄 New version available! Please refresh.');
              // Optionally show a toast notification to user
            }
          });
        });
      })
      .catch(error => {
        console.error('❌ Service Worker registration failed:', error);
      });
  });
}
